<div class="stat-or-province-wrapper">
  <div
    class="state-or-province-container"
    (click)="toggleStateDropdown()"
    [ngClass]="{ active: (isStateDropdownEnabled$ | async) }"
    #containerWrapper
  >
    <div
      class="state-body"
      [ngClass]="{ active: (isStateDropdownEnabled$ | async) }"
    >
      <div class="state-or-province-label-container">
        <!-- Update state or province withd data from CMS -->
        <span class="state-or-province-label-text">{{
          labels.stellar.sdfcard.common.stateLabel
        }}</span>
      </div>
      <ng-container>
        <div
          class="state-or-province-name-container"
          [ngClass]="{ active: (isStateDropdownEnabled$ | async) }"
        >
          <span
            *ngIf="stateOrProvinceSelected"
            class="state-or-province-name-label-text"
            [ngClass]="{ active: (isStateDropdownEnabled$ | async) }"
            >{{ stateOrProvinceSelected }}</span
          >
          <span
            *ngIf="!stateOrProvinceSelected"
            class="state-or-province-name-label-text"
            [ngClass]="{ active: (isStateDropdownEnabled$ | async) }"
            >{{ labels.stellar.sdfcard.common.selectState }}</span
          >
        </div>
      </ng-container>
    </div>
    <div
      class="icon-body"
      [ngClass]="{ active: (isStateDropdownEnabled$ | async) }"
    >
      <img
        class="icon"
        [ngClass]="{ active: (isStateDropdownEnabled$ | async) }"
        src="assets\images\arr.chevron.down.small.svg"
        alt=""
      />
    </div>
  </div>
</div>

<div class="webWrapper-absolute">
  <div
    class="divider"
    [ngClass]="{
      active: (isStateDropdownEnabled$ | async) && (isMobile$ | async) === false
    }"
  ></div>

  <div
    class="web-content-container"
    *ngIf="
      (isStateDropdownEnabled$ | async) && (isMobile$ | async) === false;
      else mobileView
    "
    (click)="$event.stopPropagation()"
    [@dropdown]
    [ngClass]="{ active: (isStateDropdownEnabled$ | async) }"
  >
    <div class="selectiveCardMenu">
      <div class="androidListMenu">
        <div class="form_iOS_search_filled">
          <div class="icon-container">
            <img
              src="assets/images/form-iOS-search-filled.svg"
              alt="search-filled-icon"
            />
          </div>
          <div class="state-input-container">
            <input
              type="text"
              class="state-input"
              [placeholder]="
                labels.stellar.sdfcard.landingPage
                  .searchForStateOrProvincePlaceholder
              "
              [formControl]="stateControl"
              [value]="displayStateOrProvinceName(stateControl.value!)"
            />
          </div>
          <div
            class="reset-icon"
            (click)="removeValue()"
            *ngIf="stateControl?.value?.length! > 0"
          >
            <img
              src="assets/images/remove-circle.svg"
              alt="remove-circle"
              [@fadeInOut]
            />
          </div>
        </div>
      </div>
    </div>
    <div class="stateSelectiveCardMenu">
      <div class="stateListMenu">
        <div class="stateGroup">
          <ng-container *ngIf="stateOrProvinceSelected">
            <div class="stateOrProvinceContainer">
              <div class="stateOrProvinceLabel">
                {{ labels.stellar.sdfcard.landingPage.stateOrProvinceSelected }}
              </div>
            </div>
            <div
              class="allStateOrProvinceContainer"
              [ngClass]="{ active: stateOrProvinceSelected }"
            >
              <div class="allStateOrProvinceLabel">
                {{ labels.stellar.sdfcard.landingPage.allStatesOrProvinces }}
              </div>
            </div>
          </ng-container>
          <div class="states-or-privinces-container">
            <ng-container
              *ngIf="
                stateOrProvinceFiltered$ | async as statesOrProvinces;
                else noResults
              "
            >
              <div
                class="state-province-item"
                *ngFor="let stateOrProvince of statesOrProvinces"
              >
                <!-- <div class="flagPlaceholder">

              </div> -->
                <div
                  class="stateOrProvinceNameContainer"
                  (click)="selectStateOrProvince(stateOrProvince.code)"
                >
                  <div class="stateOrProvinceName">
                    {{ stateOrProvince.name }}
                  </div>
                </div>
              </div>
            </ng-container>
            <ng-template #noResults>
              <div class="state-province-item">
                <!-- <div class="flagPlaceholder">

              </div> -->
                <div class="stateOrProvinceNameContainer">
                  <div class="stateOrProvinceName">
                    State or province is not found
                  </div>
                </div>
              </div>
            </ng-template>
          </div>
        </div>
      </div>
      <ng-container *ngIf="stateOrProvinceSelected">
        <div class="stateOrProvinceSelectedContainer">
          <div class="frame2608168">
            <!-- <div class="flagPlaceholder">

              </div> -->
            <div class="stateOrProvincecontainer">
              <div class="stateOrProvinceLabel">
                {{ stateOrProvinceSelected }}
              </div>
            </div>
            <img src="assets/images/checked-circle.svg" alt="checked-circle" />
          </div>
        </div>
      </ng-container>
    </div>
  </div>
  <ng-template #mobileView>
    <div
      class="mobile-content-container"
      [@slideInOutAnimation]="(isStateDropdownEnabled$ | async) ? 'in' : 'out'"
      (click)="$event.stopPropagation()"
      *ngIf="(isStateDropdownEnabled$ | async) && (isMobile$ | async)"
    >
      <div class="topBarContainer">
        <div class="topBar">
          <div class="searchFilled">
            <div class="searchIcon">
              <img
                src="assets/images/form-iOS-search-filled.svg"
                alt="search-filled-icon"
              />
            </div>
            <div class="inputText">
              <input
                type="text"
                [placeholder]="
                  labels.stellar.sdfcard.landingPage
                    .searchForStateOrProvincePlaceholder
                "
                [formControl]="stateControl"
                [value]="displayStateOrProvinceName(stateControl.value!)"
              />
            </div>
            <div
              class="reset-icon"
              (click)="removeValue()"
              *ngIf="stateControl?.value?.length! > 0"
            >
              <img
                src="assets/images/remove-circle.svg"
                alt="remove-circle"
                [@fadeInOut]
              />
            </div>
          </div>
          <div class="iconOnTheRight" (click)="toggleStateDropdown()">
            <img src="assets/images/close-icon.svg" alt="close-icon-btn" />
          </div>
        </div>
      </div>
      <div class="group12653">
        <ng-container *ngIf="stateOrProvinceSelected">
          <div class="stateOrProvinceSelectedHeader">
            <div class="stateOrProvinceSelectedLabel">
              {{ labels.stellar.sdfcard.landingPage.stateOrProvinceSelected }}
            </div>
          </div>
          <div class="recStateProvinceContainer">
            <div class="stateOrProvinceSelectedDetails">
              <div class="stateOrprovinceSelectedHeader">
                <div class="stateOrProvinceSelectedNameLabel">
                  {{ stateOrProvinceSelected }}
                </div>
              </div>
              <div class="checkMarkIcon">
                <img
                  src="assets/images/checked-circle.svg"
                  alt="checked-circle"
                />
              </div>
            </div>
          </div>
          <div class="allStatesOrProvincesHeader">
            <div class="allStatesOrProvincesLabel">
              {{ labels.stellar.sdfcard.landingPage.allStatesOrProvinces }}s
            </div>
          </div>
        </ng-container>
        <div class="frame2608167">
          <ng-container
            *ngIf="stateOrProvinceFiltered$ | async as statesOrProvinces"
          >
            <div
              class="stateOrprovinceDetails"
              *ngFor="let stateOrProvince of statesOrProvinces"
            >
              <div
                class="stateOrprovinceName"
                (click)="selectStateOrProvince(stateOrProvince.code)"
              >
                {{ stateOrProvince.name }}
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </ng-template>
  <ng-container
    *ngIf="(isStateDropdownEnabled$ | async) && (isMobile$ | async)"
  >
    <div
      class="overlay"
      (click)="$event.stopPropagation()"
      [@overlayFadeInOutAnimation]
      [ngClass]="{
        active: (isStateDropdownEnabled$ | async) && (isMobile$ | async)
      }"
    ></div>
  </ng-container>
</div>
